import { useEffect, useState } from "react";

import useEventTimer from "./useEventTimer";
import { useParams } from "react-router-dom";

export type EventType = "IADR" | "SEAADE" | "SEAADE-IADR" | undefined;

const useEvent = () => {
  const { event } = useParams<{
    event: EventType;
  }>();
  const timeBasedEvent = useEventTimer();
  const [currentEvent, setCurrentEvent] = useState<EventType>();

  useEffect(() => {
    if (event) {
      setCurrentEvent(event);
    } else if (timeBasedEvent) {
      setCurrentEvent(timeBasedEvent);
    }
  }, [event, timeBasedEvent]);

  return currentEvent;
};

export default useEvent;
